module.exports = __webpack_public_path__ + "img/4.cff98f3c.png";